import RefreshControl from '@atoms/RefreshControl/index.web';
import colors from '@theme/colors';
import React, { ReactNode, FC } from 'react';
import { FlatList, ActivityIndicator, FlatListProps } from 'react-native';
import styles from './styles';

interface Props {
  loadingList: boolean;
  listEmpty: ReactNode;
  refresh: boolean;
  onRefresh: () => void;
  transactionList: any[];
  renderItem: FlatListProps<any>['renderItem'];
  onEndReached?: () => void;
  footer?: ReactNode;
  itemSeperatorComponent?: ReactNode;
  searchHeaderComponent?: ReactNode;
}

const ShouldShowFlatListOrLoader: FC<Props> = ({
  loadingList,
  listEmpty,
  refresh,
  onRefresh,
  transactionList,
  renderItem,
  onEndReached,
  footer,
  itemSeperatorComponent,
  searchHeaderComponent,
}) => {
  if (loadingList) return <ActivityIndicator testID="loading-indicator" color={colors.secondary.orchid} size="large" />;
  return (
    <FlatList
      testID="transaction-list"
      ListEmptyComponent={listEmpty}
      refreshControl={<RefreshControl colors={[colors.secondary.orchid]} refreshing={refresh} onRefresh={onRefresh} />}
      data={transactionList}
      renderItem={renderItem}
      onEndReached={onEndReached}
      ListFooterComponent={footer}
      onEndReachedThreshold={0.6}
      keyExtractor={(item, index) => index.toString()}
      contentContainerStyle={styles.contentContainerStyle}
      ItemSeparatorComponent={itemSeperatorComponent}
      ListHeaderComponent={searchHeaderComponent}
    />
  );
};

export default ShouldShowFlatListOrLoader;
